<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con" style="padding-bottom: 0;">
        <div class="notice__page">
          <ul class="notice__page__ul">
            <li class="notice__page__li" v-for="(push, index) in pushList" :key="index" @click="moveLink(push)">
              <div class="txt">
                <p v-html="push.pushDescription"></p>
                <p class="date">{{ $Util.dateFormat(push.regDate, 'YYYY. MM. DD') }}<span class="time"><i class="i_time_gr50"></i> {{ $Util.timeFormat(push.regDate) }}</span></p>
              </div>
            </li>
          </ul>
          <infinite-loading @infinite="getPushLogListData">
            <div slot="spinner"></div>
            <div slot="no-more"></div>
            <div slot="no-results">
              <div class="complete">
                <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img">
                <span class="complete__txt__type02">내역이 없습니다.</span>
              </div>
            </div>
          </infinite-loading>
          <div class="notice__page__notice">
            <p>알림 설정은 '마이페이지' 에서 On/Off 가능합니다.</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
export default {
  components: {InfiniteLoading},
  data: function () {
    return {
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo,
        page: 1,
        limit: 20
      },
      pageInfo: null,
      pushList: []
    }
  },
  created: function () {
    this.updateReadUserPushLog()
    this.$EventBus.$emit('HeaderBar.getUserPushLogUnreadCount')
  },
  methods: {
    updateReadUserPushLog: async function () {
      await this.$CommonSvc.updateReadUserPushLog({userNo: this.params.userNo})
    },
    getPushLogListData: async function ($state) {
      const res = await this.$MypageSvc.getPushLogListData(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        this.pushList = this.pushList.concat(entity.list)
        this.pageInfo = entity.pageInfo
        this.params.page = this.params.page + 1

        if (this.pageInfo.page >= this.pageInfo.endPage) {
          $state.complete()
        }
        if (this.pageInfo.totalRow > 0) {
          $state.loaded()
        }
      } else {
        $state.complete()
        this.$Util.modalAlert({message: message})
      }
    },
    moveLink: function (push) {
      window.location.href = push.link
    }
  }
}
</script>
<style lang="scss" scoped>
.complete__img {
  margin-top: -15.5% !important;
}
</style>
